var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog",scopedSlots:_vm._u([{key:"default",fn:function(dialogProps){return [_c('DocuformDeleteConfirmation',{attrs:{"show":true,"type":dialogProps.type},on:{"close":function($event){return _vm.handleSubmit(false)},"delete":function($event){return _vm.handleSubmit(true)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }